import React from 'react';
import {
  Cobra,
  PeopleGroup,
  SupervisorAccount,
  UserCheck,
  UserClock,
  UserGear,
  UserTie,
  Location,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { EeClassesTypes } from 'types/electionService';
import { colors } from '@insurancemenu/imenu-components-lib';

export const getStockClassIcon = (name: string): JSX.Element => {
  switch (name) {
    case 'Full-Time':
      return <UserCheck width="2rem" height="2rem" color={colors.neutral[900]} />;
    case 'Part-Time':
      return <UserClock width="2rem" height="2rem" color={colors.neutral[900]} />;
    case 'Retirees':
      return <UserTie width="2rem" height="2rem" color={colors.neutral[900]} viewBox="4 2 22 22" />;
    case 'COBRA':
      return <Cobra width="2rem" height="2rem" color={colors.neutral[900]} />;
    case 'Management':
      return <PeopleGroup width="2.4rem" height="2.4rem" color={colors.neutral[900]} />;
    // return icon for custom class
    default:
      return <UserGear width="2rem" height="2rem" color={colors.neutral[900]} />;
  }
};

export const getClassIcon = (type: EeClassesTypes, name = ''): JSX.Element => {
  switch (type) {
    case 'STOCK':
      return name ? (
        getStockClassIcon(name)
      ) : (
        <SupervisorAccount width="2rem" height="2rem" color={colors.neutral[900]} />
      );
    case 'LOCATION':
      return <Location width="2.4rem" height="2.4rem" viewBox="4 0 22 22" color={colors.neutral[900]} />;
    case 'CUSTOM':
    default:
      return <UserGear width="2rem" height="2rem" color={colors.neutral[900]} />;
  }
};

export const subscriberClassTypes: EeClassesTypes[] = ['STOCK', 'LOCATION', 'CUSTOM'];

export const subscriberStockClasses = ['Full-Time', 'Part-Time', 'Retirees', 'COBRA', 'Management'];

export const normalizeSubscriberClass = (name: string): string => {
  return name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
};
